import type { CardfileData } from '@/api/cardfile/cardfileApi'

type LegalCardfileField =
  | 'shortLegalName'
  | 'fullLegalName'
  | 'legalAddress'
  | 'ipRegistrationDate'

export const getLegalFieldsFromCardfile = (
  data: CardfileData
): Array<[LegalCardfileField, string]> => {
  const values: Array<[LegalCardfileField, string | null | undefined]> = [
    ['shortLegalName', data.short_name || data.egr_short_name],
    ['fullLegalName', data.name || data.egr_name],
    ['legalAddress', data.address],
    ['ipRegistrationDate', data.egr_reg_date],
  ]
  return values.filter(
    (entry): entry is [LegalCardfileField, string] =>
      typeof entry[1] === 'string' && entry[1].length > 0
  )
}

export const isCompleteVatNumber = (value: string) => /^\d{9}$/.test(value)

export const hasCardfileInfo = (data: CardfileData) =>
  [
    data.name,
    data.egr_name,
    data.short_name,
    data.egr_short_name,
    data.address,
    data.egr_reg_date,
  ].some((value) => typeof value === 'string' && value.trim().length > 0)
